import { Fragment } from "react";
import TechQuestion from "./TechQuestion";

export default function FAQ() {
  return (
    <Fragment>
      <TechQuestion />
    </Fragment>
  );
}
